import * as React from "react";

const SourceContext = React.createContext<string | null>(null);

export const useSource = () => React.useContext(SourceContext);

export default SourceContext;
